import { render, staticRenderFns } from "./row2col.vue?vue&type=template&id=b6a90c0a&"
import script from "./row2col.vue?vue&type=script&lang=js&"
export * from "./row2col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports